<template>
  <div class="container mx-auto max-w-md px-4">
    <div class="flex mt-12">
      <div class="w-full text-center">
        <div class="icon-wrap">
          <v-icon name="unlink" class="upgrade-icon v-center" />
        </div>

        <h1 class="mb-10">Unsubscribe {{ email }} successful</h1>

        <p>
          We have successfully removed your email from this mailing list. If you
          wish to resubscribe, please visit the senders website via the original
          email and subscribe from there.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Unsubscribe",
  data() {
    return {
      email: this.$has(this.$route.query, "email")
        ? this.$route.query.email
        : "",
    };
  },
};
</script>

<style scoped>
.icon-wrap {
  @apply mx-auto block mt-4 mb-4;
  height: 100px;
  width: 100px;

  @screen md {
    @apply mt-8 mb-10;
    height: 180px;
    width: 180px;
  }
}

.upgrade-icon {
  @apply text-brand;
  font-size: 3rem;

  @screen md {
    font-size: 5rem;
  }
}
</style>
